import logo from '../assets/images/logo.png';


const LOGO =  logo;

export {
    LOGO,
}